import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { UrlHelper } from "../core/html/url-helper";
import { Lazy } from "../core/lazy";
import { ControlType } from "../devexpress/controltype";
import { DxOptionFactory } from "../devexpress/factory/dx-option-factory";
import { LoadVm } from "../loading/loadvm";
import { PopupPanelVm } from "../panels/popup-panel-vm";

export class StateStoringCopyDialogVm extends PopupPanelVm {
	public static getInstance = Lazy.singleton(StateStoringCopyDialogVm);

	constructor() {
		super();
		this.applyPopupOptions({
			title: "Layout kopieren",
			width: 400
		});
	}

	public dataSource: KnockoutObservableArray<{ name: string, uaId: number, uaFullName: string, columns: any }> = ko.observableArray([]);
	public uaId: KnockoutObservable<number> = ko.observable(null);
	public save: KnockoutObservable<boolean> = ko.observable(true);
	public callback: (state: any, save: boolean) => any;

	public okOptions = {
		onClick: (e: any) => {
			let selected = this.dataSource().find(us => us.uaId === this.uaId());
			this.callback(selected.columns, this.save());

			this.hide();
		},
		disabled: ko.computed(() => this.uaId() == null)
	};

	public uaIdOptions = DxOptionFactory.getInstance().createOptions({
		type: ControlType.SelectBox,
		options: {
			value: this.uaId,
			dataSource: this.dataSource,
			displayExpr: "uaFullName",
			valueExpr: "uaId",
		}
	});

	public saveOptions = DxOptionFactory.getInstance().createOptions({
		type: ControlType.CheckBox,
		options: {
			value: this.save
		}
	});

	public initialize() {
		this.save(true);
		this.uaId(null);
	}

	public async open(gridName: string, callback: (state: any, save: boolean) => void) {
		LoadVm.startLoading({ text: "Daten werden geladen", isHigherOverlay: true });
		let url = UrlHelper.getDataUrl("statestoring-by-name");

		let result = await DialogResultVm.getDataWithWarningDialogRetryAsync({
			method: "GET",
			url,
			params: {
				settingName: gridName
			}
		});

		this.dataSource(result);

		this.callback = callback;

		LoadVm.endLoading();
		this.show();
	}
}